import { ImagesPopup } from 'platform-components';
import React, { RefObject, useRef } from 'react';
import { useSelector } from 'react-redux';

import { getClessonLikes, getLikesMeta } from 'store/likes/selectors';

interface Props {
    clessonId: number;
    visible: boolean;
    anchorRef?: RefObject<HTMLElement>;
    onClose: () => void;
}

export const LessonsLikesPopup = (props: Props) => {
    const { clessonId, visible, anchorRef, onClose } = props;
    const rootRef = useRef<HTMLDivElement>(null);
    const likes = useSelector(getClessonLikes);
    const likesMeta: { slug: string; url: string }[] = useSelector(getLikesMeta);
    if (!likes[clessonId]) {
        return null;
    }

    const menuItems = likesMeta
        .filter((meta) => likes[clessonId][meta.slug])
        .map((meta) => ({
            url: meta.url,
            text: String(likes[clessonId][meta.slug]),
        }));

    return (
        <div ref={rootRef} style={{ position: 'relative' }}>
            {anchorRef && visible && (
                <ImagesPopup
                    anchorRef={anchorRef}
                    directions={['top', 'bottom', 'top-end', 'bottom-end']}
                    items={menuItems}
                    offset={8}
                    onClose={onClose}
                    scopeRef={rootRef}
                    visible={visible}
                />
            )}
        </div>
    );
};
